import { useMemo } from 'react';

import { useGetDriversQuery } from '#api-bridge/resourcesApi.ts';

export const useGetDriverOptions = () => {
    const { data: drivers } = useGetDriversQuery();
    return useMemo(
        () =>
            drivers?.map(driver => ({
                id: driver.id,
                label: driver.name,
            })) || [],
        [drivers]
    );
};
